//IB WALLET BALANCE

import api from "../../utils/axiosInstance.js";
import { GET_STP, GET_STP_ERROR, GET_STP_REQUEST, UPDATE_STP_DATA, REMOVE_STP, SELECTED_PAIR_DETAIL, SELECTED_PAIR_PRICE_DETAIL } from "../../ActionTypes/ActionTypes.js";


const getSTPRequest = () => ({ type: GET_STP_REQUEST });
const getSTPSuccess = (data) => ({ type: GET_STP, payload: data });
const getSTPError = (error) => ({ type: GET_STP_ERROR, payload: error });

export const getSTPList = (data) => async (dispatch) => {
    dispatch(getSTPRequest());
    try {


        const response = await api.post(`/trade/tradepair`, data);

        if (response.data.success) {
            dispatch(getSTPSuccess(response.data));

        }
        else {
            dispatch(getSTPError(response?.data?.message));
        }



    } catch (error) {
        dispatch(getSTPError(error.response?.data?.message || error.message));
    }
};

export const getAuthSTPList = (data) => async (dispatch) => {
    dispatch(getSTPRequest());
    try {


        const response = await api.post(`/trade/tradepairlist`, data);

        if (response.data.success) {
            dispatch(getSTPSuccess(response.data));

        }
        else {
            dispatch(getSTPError(response?.data?.message));
        }



    } catch (error) {
        dispatch(getSTPError(error.response?.data?.message || error.message));
    }
};

export const updateSpotTradePairData = (newData) => ({
    type: UPDATE_STP_DATA,
    payload: newData,
});


export const removeSpotTradePairData = (newData) => ({
    type: REMOVE_STP,
    payload: newData,
});

export const selectedPairDetail = (newData) => ({
    type: SELECTED_PAIR_DETAIL,
    payload: newData,
});

export const selectedPriceDetail = (newData) => ({
    type: SELECTED_PAIR_PRICE_DETAIL,
    payload: newData,
});



